/** @file addChild: adds a uniquely named child at its parent's origin and selects it. */
import type { EditorStore } from '../../state/editorTypes';
import { uniqueNodeName } from '../../panels/tree/uniqueNodeName';

/** Adds `<name>Child` (or the next free name) under `name` and selects it. */
export function addChild(store: EditorStore, name: string): void {
  const s = store.getState();
  const child = uniqueNodeName(s.puppet.doc?.puppet.nodes ?? {}, `${name}Child`);
  void s.dispatch([{ name: 'node.add', input: { name: child, node: { parent: name, pos: [0, 0, 0] } } }], `add ${child}`);
  s.select({ nodes: [child], drawable: null });
}
